module.exports = __webpack_public_path__ + "img/pancan-kea3.016ad242.png";